export default __webpack_public_path__ + "resources/icons/n420-6095.png";